module.exports = __webpack_public_path__ + "img/logo-new.b1dc7918.png";